export const HAS_USED_CRM = 'has_used_crm';
export const HAS_USED_HUBSPOT = 'has_used_hubspot';
export const SURVEY_CONFIG_STATUS = {
  NOT_FETCHED: 'not-fetched',
  FETCHING: 'fetching',
  FETCHED: 'fetched'
};
export const FEEDBACK_TEST_MODE_DEBUG_FLAG = 'feedback-components-test-mode';